import { PropsWithChildren } from 'react';

/**
 * Heading level of a row title inside a group card. The section header is the `<h2>`; a group
 * title (accordion toggle or caption) is an `<h3>`, so rows of a titled group step down to `<h4>`
 * and rows of an untitled group take the `<h3>` slot themselves (heading outline per CMS-1869).
 */
export type ProductDetailsRowHeadingLevel = 'h3' | 'h4';

export const ProductDetailsRowHeading: React.FC<
  PropsWithChildren<{ level: ProductDetailsRowHeadingLevel }>
> = ({ level, children }) => {
  const Tag = level;
  return (
    <Tag className="alpha-subheading-2 text-text/accent m-0">{children}</Tag>
  );
};
